export default "__VITE_ASSET__LTgvpGes__"